import React from 'react';
import CartPanel from '../components/CartPanel';
export default function CartPageDesktop() { return <CartPanel />; }
